import React from 'react';
import { Button } from "react-bootstrap";

const LoadingButton = ({ isLoading, name, ...rest }) => {
    return (
        <>
            <Button
                // disabled={isLoading}
                type="submit"
                className="btn-loader justify-content-center"
                {...rest}
            >
                {" "}
                {name}
                {isLoading && (
                    <>
                        &nbsp;
                        <span className="loading">
                            <i className="ri-loader-2-fill fs-16"></i>
                        </span>
                    </>
                )}
            </Button>
        </>
    );
};

export default LoadingButton;